import type { Company } from "../lib/types";

const COMPANY_COLOR_COUNT = 10;

export function companyColorIndex(value: string, colorCount = COMPANY_COLOR_COUNT) {
  let hash = 0;
  for (const character of value.trim().toLocaleLowerCase("pt-BR")) {
    hash = (hash * 31 + character.codePointAt(0)!) >>> 0;
  }
  return hash % colorCount;
}

export function CompanyBadge({
  company,
  compact = false,
  className = ""
}: {
  company?: Pick<Company, "id" | "name"> | null;
  compact?: boolean;
  className?: string;
}) {
  if (!company?.name.trim()) return null;
  const colorIndex = companyColorIndex(company.id || company.name);
  const classes = [
    "company-badge",
    `company-color-${colorIndex}`,
    compact ? "compact" : "",
    className
  ].filter(Boolean).join(" ");

  return (
    <span className={classes} title={`Empresa: ${company.name}`}>
      {company.name}
    </span>
  );
}
